import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';
import IconSheets from 'components/icons/IconSheets';

import formatSinglePlural from 'utils/formatSinglePlural';
import formatPrice from 'utils/formatPrice';

const styles = theme => ({
  root: {
    whiteSpace: 'nowrap',
    marginBottom: 15,
  },
  typography: {
    paddingTop: 5,
  },
  typographySeparator: {
    paddingTop: 5,
    color: theme.palette.primary.A100,
    marginLeft: 8,
    marginRight: 8,
  },
  separator: {
    height: 1,
    width: '100%',
    backgroundColor: theme.palette.primary.A100,
    margin: '0 20px',
  },
  link: {
    textTransform: 'uppercase',
    paddingTop: 15,
    paddingBottom: 15,
  },
  linkDisabled: {
    opacity: 1,
    color: theme.palette.primary.A400,
  },
  iconSheets: {
    width: 19,
    height: 22,
    marginBottom: -4,
    marginRight: 11,
  },
});

class ProductClaimViewHeader extends Component {
  constructor(props) {
    super(props);

    this.onPrintEditPreviewButtonClick = this.onPrintEditPreviewButtonClick.bind(this);
  }

  onPrintEditPreviewButtonClick() {
    const { ID, Patient, Prescriber, business, systemSettings, Facility, Diagnosis, Notes } = this.props;
    console.log(Notes);
    const historyState = {
      printData: {
        diagnosis: Diagnosis,
        patient: Patient,
        insurance: this.props['Primary Insurance'],
        orderLine: this.props['Order Line'],
        business,
        systemSettings,
        facility: Facility,
        orderID: ID,
        prescriber: Prescriber,
        orderNotes: Notes,
        orderInsuranceParam: this.props['Order Insurance Param'],
      },
    };
    const href = this.props['Order Line'].length > 6
      ? '/document/12?orderLines=0'
      : '/document/12';
    const newWindow = window.open(href, '_blank');
    newWindow.historyState = historyState;
  }

  render() {
    const { classes } = this.props;
    const totalCharge = this.props['Order Line'].reduce((accumulator, currentValue) => {
      const charge = currentValue.Charge ? Number(currentValue.Charge.replace(/[,$]+/g, '')) : 0;
      const units = currentValue.Units ? currentValue.Units : 0;
      return accumulator + (charge * units);
    }, 0);
    const totalCost = this.props['Order Line'].reduce((accumulator, currentValue) => {
      const cost = currentValue.Cost ? Number(currentValue.Cost.replace(/[,$]+/g, '')) : 0;
      const units = currentValue.Units ? currentValue.Units : 0;
      return accumulator + (cost * units);
    }, 0);
    return (
      <Toolbar
        className={classes.root}
        disableGutters
      >
        <Typography
          className={classes.typography}
          color="secondary"
        >
          {this.props['Order Line'].length} {formatSinglePlural({
            quantity: this.props['Order Line'].length,
            single: 'Line',
            plural: 'Lines',
          })}
        </Typography>
        <Typography
          className={classes.typographySeparator}
          color="secondary"
        >
          |
        </Typography>
        <Typography
          className={classes.typography}
          color="secondary"
        >
          Charge: {formatPrice(totalCharge)}
        </Typography>
        <Typography
          className={classes.typographySeparator}
          color="secondary"
        >
          |
        </Typography>
        <Typography
          className={classes.typography}
          color="secondary"
        >
          Cost: {formatPrice(totalCost)}
        </Typography>
        <Typography
          className={classes.typographySeparator}
          color="secondary"
        >
          |
        </Typography>
        <Typography
          className={classes.typography}
          color="secondary"
        >
          Profit: {formatPrice(totalCharge - totalCost)}
        </Typography>
        <div className={classes.separator} role="presentation" />
        <Link
          className={classes.link}
          color="primary"
          bold
          size="lg"
          onClick={this.onPrintEditPreviewButtonClick}
        >
          <IconSheets className={classes.iconSheets} />
          1500 FORM
        </Link>
      </Toolbar>
    );
  }
}

ProductClaimViewHeader.propTypes = {
  ID: PropTypes.number.isRequired,
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  Prescriber: PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }),
  'Primary Insurance': PropTypes.shape({
    ID: PropTypes.number,
  }),
  'Order Line': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  Facility: PropTypes.shape({
    ID: PropTypes.number,
  }),
  'Order Insurance Param': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
    separator: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    linkDisabled: PropTypes.string.isRequired,
    iconSheets: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimViewHeader.defaultProps = {
  'Primary Insurance': null,
  Facility: null,
  business: null,
  systemSettings: null,
  Prescriber: null,
};

export default withStyles(styles)(ProductClaimViewHeader);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaimView/ProductClaimViewHeader.js